module.exports = __webpack_public_path__ + "img/10step-02-04-1_ergebnis.4fde3358.png";